import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './puzzle-zoom.actions';
import { Injectable } from '@angular/core';
// @dynamic
@State<number>({
  name: 'puzzleZoom',
  defaults: 1,
})
@Injectable()
export class PuzzleZoomState {
  @Action(actions.SetZoom)
  SetZoom(store: StateContext<number>, action: actions.SetZoom) {
    store.setState(Math.max(Math.min(action.payload.zoom, action.payload.max), action.payload.min));
    // store.setState(action.payload.zoom);
  }

  @Action(actions.ZoomIn)
  ZoomIn(store: StateContext<number>, action: actions.ZoomIn) {
    store.setState(this.zoomIn(action.payload.factor, store.getState(), action.payload.limit));
  }

  @Action(actions.ZoomOut)
  ZoomOut(store: StateContext<number>, action: actions.ZoomOut) {
    store.setState(this.zoomOut(action.payload.factor, store.getState(), action.payload.limit));
  }

  private zoomIn(factor: number, zoom: number, limit: number) {
    return Math.min((zoom * (100 + factor)) / 100, limit);
  }

  private zoomOut(factor: number, zoom: number, limit: number) {
    return Math.max((zoom / (100 + factor)) * 100, limit);
  }
}
